import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JobInfo } from '../../jobs/models/job-info';
import { ProfileInfo } from '../../shared/models/profile-info';
import { UiStateStore } from '../../shared/store/ui-state-store.service';
import { ChatMessage } from '../models/chat-message';

@Injectable({
  providedIn: 'root'
})

export class ChatService {

  constructor(private store: AngularFirestore, private uiState: UiStateStore, private httpClient: HttpClient) { }

  get(jobId: string, employerId: string, candidateId: string): Observable<ChatMessage[]> {
    return this.store.collection("job-chats", ref => ref.orderBy('time')
      .where('jobid', '==', jobId)
      .where('employerid', '==', employerId)
      .where('candidateid', '==', candidateId))
      .valueChanges()
      .pipe(map(response => {
        return response.map(resp => ChatMessage.parse(resp));
      }),
        catchError(err => {
          this.uiState.setError(`Error when retriving messages: ${err["message"]}`);
          return throwError(err);
        }));
  }

  send(msg: ChatMessage): void {
    this.store.collection("job-chats").add(msg);
  }

  getProfileInfo(accountId: string): Observable<ProfileInfo> {
    const url = `${environment.baseApiUrl}/profiles/info/${accountId}`;
    return this.httpClient.get<ProfileInfo>(url)
      .pipe(map(response => {
        return ProfileInfo.parse(response);
      }),
        catchError(err => {
          this.uiState.setError(`Error when requesting profileinfo: ${err["message"]}`);
          return throwError(err);
        })
      );
  }

  getBusinessInfo(accountId: string): Observable<ProfileInfo> {
    const url = `${environment.baseApiUrl}/business/info/${accountId}`;
    return this.httpClient.get<ProfileInfo>(url)
      .pipe(map(response => {
        return ProfileInfo.parse(response);
      }),
        catchError(err => {
          this.uiState.setError(`Error when requesting bussiness profileinfo: ${err["message"]}`);
          return throwError(err);
        })
      );
  }

  getJobInfo(jobId: string): Observable<JobInfo> {
    const url = `${environment.baseApiUrl}/jobs/jobinfo/${jobId}`;
    return this.httpClient.get<JobInfo>(url)
      .pipe(map(response => {
        return JobInfo.parse(response);
      }),
        catchError(err => {
          this.uiState.setError(`Error when requesting job profileinfo: ${err["message"]}`);
          return throwError(err);
        })
      );
  }

}
